import styles from "./DatasetSessions.module.css";

/**
 * "Sessions" tab on the dataset-detail route. Gated by the `release-sessions`
 * feature flag in `DatasetsRoutes` and currently a placeholder pending the
 * sessions UI implementation.
 */
export function DatasetSessions() {
  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>Sessions</h2>
      <p className={styles.body}>Sessions for this dataset will appear here.</p>
    </section>
  );
}
